import { Action } from "@ngrx/store";

export enum TYPES {
  ListAttempt = "[Catalog] List Category Attempt ⏳",
  ListSuccess = "[Catalog] List Category Success 🟩",
  ListFailure = "[Catalog] List Category Failure 🟥",
}

export class ListAttempt implements Action {
  readonly type = TYPES.ListAttempt;
}

export class ListSuccess implements Action {
  readonly type = TYPES.ListSuccess;
  constructor(public payload: any) {}
}

export class ListFailure implements Action {
  readonly type = TYPES.ListFailure;
  constructor(public payload: any) {}
}

export type Union = ListAttempt | ListSuccess | ListFailure;
